import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../lib/auth';

export const BannedOverlay = () => {
  const { t } = useTranslation();
  const { logout } = useAuth();

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white px-8 text-center">
      <div className="mb-6 text-5xl">🚫</div>
      <h1 className="mb-3 text-xl font-bold text-danger">{t('bannedOverlay.title')}</h1>
      <p className="mb-2 text-sm text-gray-700">{t('bannedOverlay.body')}</p>
      <p className="mb-8 text-sm text-gray-500">
        {t('bannedOverlay.support')}{' '}
        <a href="mailto:contact@rastel.io" className="text-primary underline">
          contact@rastel.io
        </a>
      </p>
      <button
        onClick={logout}
        className="rounded-lg bg-danger px-6 py-3 text-sm font-semibold text-white"
      >
        {t('bannedOverlay.logout')}
      </button>
    </div>
  );
};
